<ng-container *ngIf="isLoadingPermissions; else permissionsLoaded">
    <ngx-skeleton-loader
        count="5"
        [theme]="{ 
            'height.px': 50
        }"
    ></ngx-skeleton-loader>
</ng-container>
<ng-template #permissionsLoaded>
    <app-data-grid-comp
        [columns]="columns"
        [bindingType]="bindingType"
        [view]="view"
        [gridData]="gridData"
        [gridDataResult]="gridDataResult"
        [isLoading]="isLoading"
        [pageSize]="pageSize"
        [skip]="skip"
        category="tbl_CompanyAssets"
        [rowSelectionSettings]="{
            canSelectRows: true,
            selectableMode: 'multiple',
            selectRowBy: 'id'
        }"
        clickableRows="true"
        [clearSelectedItems]="clearSelectedItems"
        [isLoading]="isLoading"
        [tableId]="db_tables.CompanyAssets"
        [accessAndHistoryURL]="accessAndHistoryURL"
        [parentModelId]="employeeID"
        [targetEmployeeTablePermissions]="targetEmployeeTablePermissions"
        (emitPageChangeEvent)="pageChange($event)"
        (emitOpenDialogEvent)="getCompanyAsset($event)"
        (emitDeleteEvent)="deleteCompanyAssets($event)"
    ></app-data-grid-comp>
</ng-template>